var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.593,
    height: 37.593,
    viewBox: "0 0 37.593 37.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.46,31.327H31.327v4.7a1.566,1.566,0,0,1-1.566,1.566H7.832a1.566,1.566,0,0,1-1.566-1.566v-4.7H3.133A3.137,3.137,0,0,1,0,28.195V12.531A3.137,3.137,0,0,1,3.133,9.4H6.265V1.566A1.566,1.566,0,0,1,7.832,0H29.761a1.566,1.566,0,0,1,1.566,1.566V9.4H34.46a3.137,3.137,0,0,1,3.133,3.133V28.195A3.137,3.137,0,0,1,34.46,31.327ZM9.4,34.46h18.8V23.5H9.4Zm18.8-31.327H9.4V9.4h18.8Zm6.265,9.4H3.133V28.195H6.265V21.929a1.566,1.566,0,0,1,1.566-1.566H29.761a1.566,1.566,0,0,1,1.566,1.566v6.265H34.46Zm-4.7,4.7a1.566,1.566,0,0,1,0-3.133h1.566a1.566,1.566,0,0,1,0,3.133Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterWhite);
export default __webpack_public_path__ + "static/media/printer-white.a2cd6119603aeaf18648add7a6e41e77.svg";
export { ForwardRef as ReactComponent };